import * as React from 'react';
import { SVGProps } from 'react';

const IconLayersSizeM = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M12.663 1.286a1.4 1.4 0 0 0-1.252 0L2.442 5.77a.8.8 0 0 0-.01 1.426l8.96 4.643a1.4 1.4 0 0 0 1.289 0l8.96-4.643a.8.8 0 0 0-.01-1.426l-8.968-4.484z" />
    <path d="m3.983 10-1.54.77a.8.8 0 0 0-.011 1.426l8.96 4.644a1.4 1.4 0 0 0 1.289 0l8.96-4.644a.8.8 0 0 0-.01-1.426l-1.54-.77-7.41 3.84a1.4 1.4 0 0 1-1.288 0L3.982 10z" />
    <path d="m3.983 15.027-1.54.77a.8.8 0 0 0-.011 1.426l8.96 4.643a1.4 1.4 0 0 0 1.289 0l8.96-4.643a.8.8 0 0 0-.01-1.426l-1.54-.77-7.41 3.84a1.4 1.4 0 0 1-1.288 0l-7.41-3.84z" />
  </svg>
);
export default IconLayersSizeM;
